import { SOGetAssessmentSummary } from '../assessment-summary/so-get-assessment-summary';
import { SOGetReport } from '../report/so-get-report';
import { SOGetProject } from '../project/so-get-project';
import { SOGetOrganization } from '../organization/so-get-organization';
import {MMQueryOptions} from 'lionheartland';
import {QueryProtocol} from 'lionheartland';


export class SOGetAssessment implements QueryProtocol {

  constructor(
    public uid: string = null,
    public name: string = null,
    public assessmentSummary: SOGetAssessmentSummary = null,
    public report: SOGetReport = null,
    public project: SOGetProject = null,
    public organization: SOGetOrganization = null,
    public predicate: string = null,
    public queryOptions: MMQueryOptions = new MMQueryOptions(),
  ) {
  }
  static construct(params: {[key: string]: any}) {
    return new SOGetAssessment(
      'uid' in params ? params.uid : null,
      'name' in params ? params.name : null,
      'assessmentSummary' in params ? params.assessmentSummary : null,
      'report' in params ? params.report : null,
      'project' in params ? params.project : null,
      'organization' in params ? params.organization : null,
      'predicate' in params ? params.predicate : null,
      'queryOptions' in params ? params.queryOptions : new MMQueryOptions(),
    );
  }
}
